export enum ReviewEntryQuestionSeverity {
  High = 'high',
  Low = 'low',
  Medium = 'medium',
}
